// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"presentation_wrapper__rflEz","button":"presentation_button__Zi5g9"};